<i class="color-noti fa fa-shower fa-2x"> <button *ngIf="item > 1" type="button"
        class="notification-align btn btn-danger btn-circle">{{item -1}}</button></i>